import { FC } from 'react'

import ConnectedBaseScheduleShiftDetail from './connectors/ConnectedBaseScheduleShiftDetail/ConnectedBaseScheduleShiftDetail'

const BaseScheduleShiftDetail: FC = () => (
    <main className="page">
        <ConnectedBaseScheduleShiftDetail />
    </main>
)

export default BaseScheduleShiftDetail
